/**
 * I passi del tutorial guidato della pagina "Analisi prezzi" eBay.
 *
 * Niente da preparare prima dei passi: i bersagli che dipendono dai dati hanno
 * `timeout: 250`, cosi' a elenco vuoto la card si aggancia in basso senza attese.
 */
export function createPriceAnalysisTourSteps() {
	return [
		{
			body: `Qui trovi le tue inserzioni eBay: subito quelle associate ai tuoi prodotti, e con "Aggiorna elenco" anche le altre. Su eBay non esiste la buybox: per i prodotti che segui cerchiamo le inserzioni degli altri venditori con lo stesso EAN e confrontiamo i totali che paga il cliente, prezzo piu' spedizione. E' tutto manuale.`,
			key: 'intro',
			placement: 'bottom',
			target: '[data-tour="tutorial"]',
			title: 'Analisi prezzi eBay',
		},
		{
			body: `Ogni paese eBay ha il suo elenco, le sue stelline e le sue ricerche. Nella tendina compaiono i paesi dove hai inserzioni.`,
			key: 'country',
			placement: 'bottom',
			target: '[data-tour="country"]',
			title: 'Scegliere il paese',
		},
		{
			body: `E' lo stesso aggiornamento della pagina Associa prodotti: un solo download del report eBay aggiorna entrambe le pagine e aggiunge qui le inserzioni non associate. Stelline e ricerche gia' fatte restano.`,
			key: 'scan',
			placement: 'bottom',
			target: '[data-tour="scan"]',
			title: 'Aggiorna elenco',
		},
		{
			body: `La stellina gialla indica un prodotto seguito: solo i prodotti seguiti vengono confrontati. Serve l'EAN: le righe "Senza EAN" non si possono confrontare finche' non lo aggiungi al prodotto.`,
			key: 'follow',
			placement: 'right',
			target: '[data-tour="follow"]',
			timeout: 250,
			title: 'Seguire un prodotto',
		},
		{
			body: `Cerca su eBay, per ogni prodotto seguito, le inserzioni con lo stesso EAN. Si fa una ricerca per prodotto (eBay non permette di cercarne piu' insieme) e il limite giornaliero di chiamate e' condiviso: per questo ogni ricerca ha un tetto di prodotti e parte prima da quelli cercati meno di recente. Prima di partire ti diciamo quanti prodotti e quanto tempo; poi va in coda e arriva una notifica alla fine.`,
			key: 'analysis',
			placement: 'bottom',
			target: '[data-tour="analysis"]',
			title: 'Ricerca concorrenti',
		},
		{
			body: `Filtra l'elenco: solo i prodotti seguiti, oppure per esito del confronto. "Piu' cari di un concorrente" e' il punto di partenza per capire dove intervenire.`,
			key: 'filters',
			placement: 'bottom',
			target: '[data-tour="filters"]',
			title: 'Filtri',
		},
		{
			body: `Sotto il nostro prezzo c'e' la nostra spedizione e il totale, in rosso quando un concorrente costa meno. Accanto il concorrente piu' economico (cliccabile, con venditore e spedizione) e la nostra posizione fra tutte le offerte trovate.`,
			key: 'table',
			placement: 'top',
			target: '[data-tour="table"]',
			timeout: 250,
			title: 'Come si legge una riga',
		},
		{
			body: `Propone il prezzo con cui il nostro totale sta un centesimo sotto quello del concorrente, e puoi modificarlo. Il prezzo va subito a eBay (per le inserzioni create da AZ Seller come la "Modifica" della pagina eBay, per le altre con la Trading API): se eBay lo accetta viene salvato anche sul prodotto, altrimenti vedi il motivo.`,
			key: 'adjust',
			placement: 'left',
			target: '[data-tour="adjust"]',
			timeout: 250,
			title: 'Aggiusta prezzo',
		},
		{
			body: `Con le schede sotto il titolo passi alle altre pagine della sezione eBay: Inserzioni, Associa prodotti, Regole feed e Repricing.`,
			key: 'tabs',
			placement: 'bottom',
			target: '[data-tour="tabs"]',
			title: 'Le altre pagine',
		},
	];
}
